import './jquery';
import 'bootstrap';
import './popper';
import './selectize';
import './datatable';
import 'jstree';
import 'bootstrap-colorpicker';
import './i18n';
import 'flatpickr';
import 'summernote';
import './google-maps';
import 'chart.js';
import './lodash';
import '../../javascripts/debugDialog.jsx';



// WEBPACK FOOTER //
// ./app/assets/granite/js/app.js